import { featureRoute } from '../helpers';
import { RoversRangersStages } from '../../constants/AppConstants';

export default featureRoute('enableRoversRangers', RoversRangersStages.SEARCH, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/roversRangers/Search').default);
        }, 'roversrangers');
    }
});
